import { useMemo } from "react";

import type { DiscountOrdinaryForOrdinaryQuery } from "@/lib/gql/__generated__/graphql";

import * as Converter from "./converter";
import * as DiscountItemOrdinaryShared from "../../../../_shared";
import { useEditDiscountOrdinaryFormModel } from "../../model";
import { useUpdateDiscountOrdinary } from "../use-update-discount-ordinary";

type Props = {
	hotelID: string;
	discountOrdinaryForOrdinaryServerModel: DiscountOrdinaryForOrdinaryQuery;
};

export const useInitialized = ({ hotelID, discountOrdinaryForOrdinaryServerModel }: Props) => {
	const initInputModel = useMemo(
		() => Converter.serverModelToInputModelConverter(hotelID, discountOrdinaryForOrdinaryServerModel),
		[discountOrdinaryForOrdinaryServerModel, hotelID],
	);

	const { inputModel, viewModel, onSetViewModel, onResetViewModel } =
		useEditDiscountOrdinaryFormModel(initInputModel);

	const {
		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,
		// ディスカウント対象の変更
		onChangeIsPlanDiscountEligible,
		onChangeIsRoomDiscountEligible,
		onChangeIsOptionDiscountEligible,
		onChangeIsAdditionalFeeDiscountEligible,
		// ディスカウント方法の変更
		onChangeDiscountType,
		// ディスカウント金額の変更（一定割合）
		onChangeDiscountWithRatio,
		// ディスカウント金額の変更（固定金額）
		onChangeDiscountWithStatic,
		// ディスカウント方法の変数の変更（顧客属性）
		onChangeStaticTargetType,
		// ディスカウント方法の変数の変更（期間）
		onChangeStaticTermType,

		// 追加設定
		// 最低価格の変更
		onChangeResourceLowestPrice,
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	} = DiscountItemOrdinaryShared.Model.UseCase.useActions(viewModel, onSetViewModel);
	const { onUpdateDiscountOrdinary } = useUpdateDiscountOrdinary({ inputModel, onResetViewModel });

	return {
		//
		viewModel,
		// mutation
		onUpdateDiscountOrdinary,

		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,
		// ディスカウント対象の変更
		onChangeIsPlanDiscountEligible,
		onChangeIsRoomDiscountEligible,
		onChangeIsOptionDiscountEligible,
		onChangeIsAdditionalFeeDiscountEligible,
		// ディスカウント方法の変更
		onChangeDiscountType,
		// ディスカウント金額の変更（一定割合）
		onChangeDiscountWithRatio,
		// ディスカウント金額の変更（固定金額）
		onChangeDiscountWithStatic,
		// ディスカウント方法の変数の変更（顧客属性）
		onChangeStaticTargetType,
		// ディスカウント方法の変数の変更（期間）
		onChangeStaticTermType,

		// 追加設定
		// 最低価格の変更
		onChangeResourceLowestPrice,
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	};
};
